import script from "./demo-day-rules.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-day-rules.vue?vue&type=script&setup=true&lang=js"

import "./demo-day-rules.vue?vue&type=style&index=0&id=ca2ce9d2&lang=css"

const __exports__ = script;

export default __exports__